import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const IdentityDetailsVietnam = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { idCardNo, errors } = formState;

  const inputElements = [
    {
      belongsTo: [
        'Vietnam Consumer Data',
        'Vietnam National ID',
        'Vietnam Social Security',
      ],
      element: (
        <TextFieldGroup
          key="idCardNo"
          id="idCardNo"
          type="text"
          name="idCardNo"
          dataName="idCardNoVN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.idCardNo')}
          value={idCardNo}
          placeholder={transUTL('translatePlaceholder.inputVN.idCardNo')}
          placeholderTrigger={isEmptyVAL(idCardNo) ? 'input-empty' : ''}
          error={errors.idCardNo}
          errorTrigger={errors.idCardNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

IdentityDetailsVietnam.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default IdentityDetailsVietnam;
